export default "__VITE_ASSET__JU60GBix__"